import React from "react";
import { X, Moon, Sun, Minimize2, Maximize2 } from "lucide-react";
import LogoImage from "./LogoImage";
import { useGoogleFont } from "../hooks/useGoogleFont.js";
import { cn } from "../lib/utils.js";

const ChatHeader = ({
  conciergeName,
  companyName,
  companyLogo,
  primaryColor,
  isDark,
  isMinimized = false,
  textColor,
  fontFamily,
  fontSize,
  onToggleTheme,
  onMinimize,
  onClose,
  headerTextBold = false,
  headerTextItalic = false,
}) => {
  useGoogleFont(fontFamily);

  const agentData = {
    fontFamily,
    fontSize,
    headerTextBold,
    headerTextItalic,
    textColor,
  };

  return (
    <div
      className={`text-white ${isMinimized ? "px-4 py-2.5" : "px-2 py-4"
        } flex items-center justify-between relative overflow-hidden rounded-t-2xl`}
      style={{
        background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}dd 100%)`,
        fontFamily,
      }}
    >
      <div className="flex gap-2 w-96">
        <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent pointer-events-none"></div>
        {companyLogo && (
          <div className="w-[48px] h-[48px] rounded-full overflow-hidden flex items-center justify-center bg-white/10">
            <LogoImage src={companyLogo} />
          </div>
        )}
        <div
          className={`flex items-center gap-2 ${!companyLogo ? "px-3" : ""}`}
          style={{
            fontFamily: agentData?.fontFamily || "Inter",
          }}
        >
          <h3
            className={cn(
              "font-semibold leading-tight",
              agentData?.headerTextBold && "font-bold",
              agentData?.headerTextItalic && "italic"
            )}
            style={{
              fontSize: agentData?.fontSize
                ? `calc(${agentData.fontSize} + 2px)`
                : "15px",
              color: agentData?.textColor || "#FFFFFF",
            }}
          >
            {conciergeName}
          </h3>
        </div>
      </div>
      <div className="flex items-center gap-0 relative z-10 text-white flex-shrink-0 ml-1">
        <span
          role="button"
          tabIndex={0}
          aria-label="Toggle theme"
          onClick={onToggleTheme}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onToggleTheme?.(event);
            }
          }}
          className="inline-flex h-7 w-7 items-center justify-center cursor-pointer transition-opacity duration-200 hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40 rounded-full"
        >
          {isDark ? <Sun className="w-3.5 h-3.5" strokeWidth={1.6} /> : <Moon className="w-3.5 h-3.5" strokeWidth={1.6} />}
        </span>
        {/* {onMinimize && (
          <span
            role="button"
            tabIndex={0}
            aria-label={isMinimized ? "Expand" : "Minimize"}
            onClick={onMinimize}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onMinimize?.(event);
              }
            }}
            className="inline-flex h-7 w-7 items-center justify-center cursor-pointer transition-opacity duration-200 hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40 rounded-full"
          >
            {isMinimized ? (
              <Maximize2 className="w-3.5 h-3.5" strokeWidth={1.6} />
            ) : (
              <Minimize2 className="w-3.5 h-3.5" strokeWidth={1.6} />
            )}
          </span>
        )} */}
        <span
          role="button"
          tabIndex={0}
          aria-label="Close"
          onClick={onClose}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onClose?.(event);
            }
          }}
          className="inline-flex h-7 w-7 items-center justify-center cursor-pointer transition-opacity duration-200 hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40 rounded-full"
        >
          <X className="w-3.5 h-3.5" strokeWidth={1.6} />
        </span>
      </div>
    </div>
  );
};

export default ChatHeader;
